import React from "react";
import copilotLogo from "../assets/copilot-logo.png";
import {AGENTS, type AgentId} from "../showcaseData";

/** Logo mark — used as a chat avatar. Both sides are Microsoft Copilot (official mark). */
export const AgentMark: React.FC<{ agent: AgentId; size?: number }> = ({agent, size = 26}) => (
    <span className={`dqs-brand-mark brand-${agent}`}>
        <img src={copilotLogo} width={size} height={size} alt="Microsoft Copilot"/>
    </span>
);

/** Branded mark + product name — used as the chat panel header. */
export const AgentBrand: React.FC<{ agent: AgentId }> = ({agent}) => (
    <div className={`dqs-brand brand-${agent}`}>
        <AgentMark agent={agent} size={22}/>
        <span className="dqs-brand-name">{AGENTS[agent].name}</span>
    </div>
);
